import React, { forwardRef, LegacyRef, useContext } from 'react'

import { Row } from '@vividseats/vivid-ui-kit'

import filterContext from '@/components/pages/production/components/context'
import GroupFilterChipRow from '@/components/pages/production/components/filters/group-chips'
import FilterButton from '@/components/shared/filters/filter-button'

import PriceFilterButton from './components/price-filter-button'
import QuantityFilter from './components/quantity-filter'
import styles from './styles.module.scss'

interface Props {
    clickFilters: () => void
    ref?: React.Ref<unknown>
}
const SHEET_TRANSITION_MS = 500

const ExposedFilter: React.ForwardRefExoticComponent<Props> = forwardRef(({ clickFilters }, ref) => {
    const { state: filterState } = useContext(filterContext)
    const handleOpen = () => clickFilters()
    const handleOpenAndScrollToPrice = () => {
        clickFilters()
        setTimeout(() => {
            const minPriceInput = document.querySelector('[data-testid="priceMin"]')
            if (minPriceInput) {
                minPriceInput.scrollIntoView({ behavior: 'smooth', block: 'start' })
            }
        }, SHEET_TRANSITION_MS) // sheet transition costs 500ms
    }
    return (
        <div
            className={styles.exposedFilterWrapper}
            ref={ref as LegacyRef<HTMLDivElement>}
            data-testid="exposed-filter"
            id="exposed-filter"
        >
            <Row align="center" justify="between" className={styles.exposedFilter}>
                <FilterButton
                    iconType="filter"
                    onClick={handleOpen}
                    className={styles.filterBtn}
                    modifiedFilterList={filterState.modifiedFilterList}
                />
                <div className={styles.flexDisplay}>
                    <PriceFilterButton onClick={handleOpenAndScrollToPrice} />
                    <QuantityFilter />
                </div>
            </Row>
            <GroupFilterChipRow />
        </div>
    )
})

export default ExposedFilter
